import React, { useState, useRef } from 'react';

import { IconButton, Popover, Button } from '@material-ui/core';
import { Menu, Check, Close } from '@material-ui/icons';
import PropTypes from 'prop-types';

import { t } from '~/helpers';

import { Container, Content, MyForm } from './styles';

export default function Card({
  icon,
  title,
  filter,
  children,
  toggleOpen,
  initials,
  onSubmit,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);

  const formRef = useRef(null);

  async function handleSubmit(params) {
    await setLoading(true);

    try {
      await onSubmit(params);
    } catch (err) {
      console.log(err);
    } finally {
      await setLoading(false);
      setAnchorEl(null);
    }
  }

  return (
    <>
      <Container>
        <header>
          <div className="title">
            {icon}
            <h1>{title}</h1>
          </div>

          {filter && (
            <IconButton
              onClick={({ currentTarget }) => {
                setAnchorEl(anchorEl ? null : currentTarget);
                toggleOpen();
              }}
              color="primary"
            >
              <Menu />
            </IconButton>
          )}
        </header>
        <Content>{children}</Content>
      </Container>

      <Popover
        id={anchorEl ? 'simple-popper' : undefined}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={() => setAnchorEl(null)}
      >
        <MyForm ref={formRef} initialData={initials} onSubmit={handleSubmit}>
          {filter}

          <div className="buttons">
            <Button
              startIcon={<Check />}
              color="primary"
              variant="outlined"
              onClick={() => formRef.current.submitForm()}
              disabled={loading}
            >
              {t('s.geral.botaoconfirmar')}
            </Button>

            <Button
              startIcon={<Close />}
              color="secondary"
              variant="outlined"
              onClick={() => setAnchorEl(null)}
              disabled={loading}
            >
              {t('s.geral.botaovoltar')}
            </Button>
          </div>
        </MyForm>
      </Popover>
    </>
  );
}

Card.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
  title: PropTypes.string.isRequired,
  filter: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
  toggleOpen: PropTypes.func,
  initials: PropTypes.objectOf(PropTypes.any),
  onSubmit: PropTypes.func,
};

Card.defaultProps = {
  filter: null,
  toggleOpen: () => {},
  initials: {},
  onSubmit: () => {},
};
